export default __webpack_public_path__ + "static/13071969_10208286005800072_5156529709577657469_o-450x520-db003af0b69193aa709701e263efc2fd.jpg";